<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['loadMore']);

const { t } = useI18n();

// MedUp overlay: auto-load on scroll. A sentinel near the bottom triggers
// `loadMore` as soon as it approaches the viewport (rootMargin), turning the
// "Load more" button into true infinite scroll. The button stays as a fallback.
const sentinel = ref(null);
let observer = null;

onMounted(() => {
  if (typeof IntersectionObserver === 'undefined') return;
  observer = new IntersectionObserver(
    entries => {
      if (entries[0]?.isIntersecting && !props.isLoading) {
        emit('loadMore');
      }
    },
    { rootMargin: '400px 0px' }
  );
  if (sentinel.value) observer.observe(sentinel.value);
});

onBeforeUnmount(() => {
  observer?.disconnect();
  observer = null;
});
</script>

<template>
  <div ref="sentinel" class="flex justify-center py-4">
    <Button
      :label="t('CONTACTS_LAYOUT.LOAD_MORE')"
      :is-loading="isLoading"
      variant="faded"
      color="slate"
      size="sm"
      @click="emit('loadMore')"
    />
  </div>
</template>
